import { ConfigProvider, theme as algoTheme } from "antd";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@src/providers/auth/provider";

import { CompanyProvider } from "./providers/company/provider";
import { useTheme } from "./providers/theme/useTheme";
import { router } from "./router";

const App = () => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0047ab",
          borderRadius: 12,
        },
        components: {
          Layout: {
            // 20% darker than primary color
            headerBg: "#003989",
          },
        },
        algorithm:
          theme === "dark"
            ? algoTheme.darkAlgorithm
            : algoTheme.defaultAlgorithm,
      }}
    >
      <AuthProvider>
        <CompanyProvider>
          <RouterProvider router={router} />
        </CompanyProvider>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
